{
	"title": "Usługa niedostępna (500)",
	"description": "Spróbuj odświeżyć tę stronę lub sprawdź połączenie internetowe. Jeśli błąd będzie się powtarzał, zgłoś go jako błąd (bug), abyśmy mogli podjąć działania.",
	"primaryButtonTitle": "Odśwież stronę",
	"secondaryButtonTitle": "Skopiuj dziennik błędów",
	"errorLogCopiedMessage": "Dziennik błędów skopiowany",
	"traceparentLabel": "Traceparent"
}
